import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { ModalOverlay, ModalBox } from './styles/LoadingModalStyled';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const duration = 0.2;
const modalBoxVariants = {
  in: {
    opacity: 1,
    x: 0,
    transition: { duration },
  },
  out: {
    opacity: 0,
    x: -400,
    transition: { duration },
  },
};

const LoadingModal = ({ title, className, body }) => {
  const portalRoot = typeof window !== 'undefined' ? document.body : null;
  const content = (
    <AnimatePresence>
      <ModalOverlay>
        <ModalBox
          as={motion.div}
          variants={modalBoxVariants}
          initial="out"
          animate="in"
          exit="out"
          className={className}
        >
          <LoadingSpinner title={title} body={body} />
        </ModalBox>
      </ModalOverlay>
    </AnimatePresence>
  );

  return portalRoot && createPortal(content, portalRoot);
};

LoadingModal.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  body: PropTypes.string,
};

LoadingModal.defaultProps = {
  title: 'Cargando...',
  className: '',
  body: '',
};

export default LoadingModal;
